import { service } from '../../../../helpers/http'

export const ActionTypeSubscriptionIndex = ({ dispatch }, payload) => {
    return service({
        module: 'typeSubscription',
        action: 'typeSubscriptionIndex',
        payload: payload
    })
}

export const ActionTypeInstitutionSubscriptionIndex = ({ dispatch }, payload) => {
    return service({
        module: 'typeSubscription',
        action: 'typeInstitutionSubscriptionIndex',
        payload: payload
    })
}

export const ActionTypeInstitutionSubscriptionStore = ({ dispatch }, payload) => {
    return service({
        module: 'typeSubscription',
        action: 'typeInstitutionSubscriptionStore',
        payload: payload
    })
}

export const ActionTypeInstitutionSubscriptionUpdate = ({ dispatch }, payload) => {
    return service({
        module: 'typeSubscription',
        action: 'typeInstitutionSubscriptionUpdate',
        payload: payload
    })
}

export const ActionTypeInstitutionSubscriptionDestroy = ({ dispatch }, payload) => {
    return service({
        module: 'typeSubscription',
        action: 'typeInstitutionSubscriptionDestroy',
        payload: payload
    })
}